import React from 'react'
import { useStyles } from './styles.js'

const EnphaseLogo = () => {
  const classes = useStyles()
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
      width="50%"
      viewBox="0 0 144 24.93"
      className={classes.svgDimensions}
    >
      <path
        className="a"
        fill="#FFF"
        d="M12.2,24.9A12.32,12.32,0,0,1,1,17.8a1.5,1.5,0,1,1,2.7-1.3,9.22,9.22,0,0,0,8.8,5.3,9.34,9.34,0,0,0,8.1-5.3,1.5,1.5,0,1,1,2.7,1.3,12.29,12.29,0,0,1-10.7,7.1C12.5,24.8,12.3,24.9,12.2,24.9Z"
      />
      <path
        className="a"
        fill="#FFF"
        d="M22.8,13.8H1.5a1.5,1.5,0,0,1,0-3H21.1A9.35,9.35,0,0,0,3.6,8,1.48,1.48,0,0,1,1,6.6a12.3,12.3,0,0,1,23.2,5.7,2.1,2.1,0,0,1-.4,1.1A1.53,1.53,0,0,1,22.8,13.8Z"
      />
      <path
        className="b"
        fill="#FFF"
        d="M42.5,18H34.6V13.6h5.6a1.4,1.4,0,0,0,0-2.8H34.6V7h7.3a1.37,1.37,0,0,0,1.4-1.4,1.37,1.37,0,0,0-1.4-1.4H33.2a1.37,1.37,0,0,0-1.4,1.4V19.3a1.37,1.37,0,0,0,1.4,1.4h9.3a1.37,1.37,0,0,0,1.4-1.4A1.34,1.34,0,0,0,42.5,18Z"
      />
      <path
        className="b"
        fill="#FFF"
        d="M138.2,18h-7.9V13.6h5.6a1.4,1.4,0,0,0,0-2.8h-5.6V7h7.3A1.37,1.37,0,0,0,139,5.6a1.37,1.37,0,0,0-1.4-1.4h-8.7a1.37,1.37,0,0,0-1.4,1.4V19.3a1.37,1.37,0,0,0,1.4,1.4h9.3a1.37,1.37,0,0,0,1.4-1.4A1.29,1.29,0,0,0,138.2,18Z"
      />
      <path
        className="b"
        fill="#FFF"
        d="M103,4.4a1.4,1.4,0,0,0-1.2.8L97.7,15h0l-1.6,3.7a1.36,1.36,0,0,0,.7,1.8,1.09,1.09,0,0,0,.5.1,1.56,1.56,0,0,0,1.3-.8l1.2-2.9h6.5l1.2,2.9a1.34,1.34,0,0,0,1.3.8.75.75,0,0,0,.5-.1,1.36,1.36,0,0,0,.7-1.8L108.4,15h0s-4-9.4-4.1-9.8A1.34,1.34,0,0,0,103,4.4Zm-2,9.8,2.1-5,2.1,5Z"
      />
      <path
        className="b"
        fill="#FFF"
        d="M59.2,20.7h-.3a1.61,1.61,0,0,1-1.1-.5L49.4,9.3v10a1.4,1.4,0,1,1-2.8,0V5.8A1.37,1.37,0,0,1,48,4.4h.3a1.61,1.61,0,0,1,1.1.5l8.5,10.9V5.8a1.4,1.4,0,0,1,2.8,0V19.3A1.52,1.52,0,0,1,59.2,20.7Z"
      />
      <path
        className="b"
        fill="#FFF"
        d="M91.8,4.4a1.37,1.37,0,0,0-1.4,1.4v5.1H82.6V5.8a1.4,1.4,0,0,0-2.8,0v6.5h0v7a1.4,1.4,0,1,0,2.8,0V13.6h7.8v5.7a1.4,1.4,0,1,0,2.8,0V5.8A1.37,1.37,0,0,0,91.8,4.4Z"
      />
      <path
        className="b"
        fill="#FFF"
        d="M118.2,21a7.87,7.87,0,0,1-5.6-2.3,1.34,1.34,0,1,1,1.9-1.9,5.54,5.54,0,0,0,5.1,1.3,1.92,1.92,0,0,0,1.5-1.5c.1-.8-.3-1.5-2.7-2.5l-.6-.3c-.1-.1-.3-.1-.6-.2-1.5-.6-4.7-1.9-4.6-4.8a4.26,4.26,0,0,1,2.9-4,7.23,7.23,0,0,1,7.6,1.7,1.34,1.34,0,1,1-1.9,1.9,4.57,4.57,0,0,0-4.7-1.1,1.56,1.56,0,0,0-1.2,1.5c0,1.1,1.9,1.8,2.9,2.2a6.89,6.89,0,0,1,.8.3.76.76,0,0,1,.4.2c1.4.6,4.8,2.1,4.3,5.4a4.73,4.73,0,0,1-3.4,3.7A4.64,4.64,0,0,1,118.2,21Z"
      />
      <path
        className="b"
        fill="#FFF"
        d="M66.2,20.7a1.37,1.37,0,0,1-1.4-1.4V5.8a1.37,1.37,0,0,1,1.4-1.4h5.6a5,5,0,0,1,5.3,5.1,5,5,0,0,1-5.3,5.1H67.6v4.7A1.37,1.37,0,0,1,66.2,20.7Zm1.4-8.9h4.2a2.29,2.29,0,0,0,2.5-2.4A2.34,2.34,0,0,0,71.8,7H67.6Z"
      />
    </svg>
  )
}
export default EnphaseLogo
